import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  title: 'Te paralizás cada vez que te alejás de él',
  desc: 'Sin saber si en el momento que mirés para otro lado va a tener una convulsión y nadie va a saber qué hacer.',
  emoji: '😰'
}, {
  title: 'Terminás en la guardia y salís sin respuestas claras',
  desc: 'Sin importar cuántas veces vayas, siempre sentís que te dan información incompleta y salís igual de asustada que entraste.',
  emoji: '🏥'
}, {
  title: 'No sabés si lo que está comiendo afecta las crisis',
  desc: 'Sin información concreta sobre qué alimentos pueden aumentar la frecuencia de convulsiones en tu hijo específico.',
  emoji: '😤'
}, {
  title: 'La medicación lo cambia y no entendés por qué',
  desc: 'Sin nadie que te explique que la irritabilidad, el sueño alterado y los cambios de humor son efectos conocidos de los antiepilépticos.',
  emoji: '💊'
}, {
  title: 'Le prohibís todo por miedo',
  desc: 'Sin saber qué actividades son seguras, cuáles necesitan supervisión y cuáles realmente hay que evitar.',
  emoji: '🎽'
}, {
  title: 'El colegio no sabe qué hacer con él',
  desc: 'Sin un protocolo claro que le explique a la maestra exactamente qué hacer si tiene una crisis durante las 6 horas que no estás.',
  emoji: '📚'
}, {
  title: 'Tu familia no entiende la enfermedad',
  desc: 'Sin recursos para explicarle al papá, los abuelos y los hermanos cómo actuar, qué decir y cómo no empeorar la situación.',
  emoji: '👨‍👩‍👧'
}, {
  title: 'La obra social te rechaza cosas y no sabés cómo reclamar',
  desc: 'Sin conocer tus derechos ni cómo hacer un reclamo efectivo para conseguir la cobertura que le corresponde a tu hijo.',
  emoji: '📋'
}];
export const PainPoints = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-cream" data-id="element-213">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center mb-6 sm:mb-10" data-id="element-215">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-216">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-id="element-217">
            Si tenés un hijo con epilepsia en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-6" data-id="element-218">
          {painPoints.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex gap-3 sm:gap-4 bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow-sm border border-brand-orange/10" data-id="element-219">
              <div className="flex-shrink-0 mt-1 text-xl sm:text-2xl" data-id="element-220">
                {pain.emoji}
              </div>
              <div data-id="element-221">
                <h3 className="font-bold text-gray-900 mb-1 text-sm sm:text-base" data-id="element-222">
                  {pain.title}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed" data-id="element-223">
                  {pain.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 sm:mt-14 md:mt-16 text-center" data-id="element-224">
          <p className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-brand-orange px-4" data-id="element-225">
            ¿Cuánto tiempo más vas a manejar la epilepsia de tu hijo sin un
            sistema?
          </p>
        </motion.div>
      </div>
    </section>;
};